<div class="admin-container">
  <form class="form">
    <div class="input-group">
      <label>Username</label>
      <input pInputText type="text" name="username" [(ngModel)]="userModel.username">
    </div>
    <div class="input-group">
      <label>Password</label>
      <input pInputText type="password" name="password" [(ngModel)]="userModel.password">
    </div>
    <button pButton class="submit" (click)="login()" label="Login"></button>
  </form>
</div>